import axios from 'axios';
import { map, omitBy, isEmpty, isNil, omit, find } from 'lodash';
import { apiURL } from '../helpers';
import { errorHandler } from '../utils';

import bannerList from 'Data/banner-layout.json';

// export const fetchBanners = async () => {
//   const file = '/banners.json';

//   try {
//     const response = await axios.get(file);
//     return response;
//   }
//   catch(err) {
//     console.log(err.message)
//     return { error: { message: err.message }};
//   }
// }

interface FetchBannersPayload {
  filters?: { isLandingPage?: boolean; active?:boolean; sourceSite?: string; layoutStyle?: string; bannerType?: string; totalCount?: boolean };
  paginations?: { offset: number; limit: number };
  sorting?: { sortBy: string; mode: 'ASC' | 'DESC'; };
}

export const fetchBanners = async ({ filters, paginations, sorting }: FetchBannersPayload) => {
  const url = apiURL('/banner/list');
  // const layoutStyle = find(bannerList, (element) => element.NumberOfSideBanners === 6)?.layoutStyle;

  try {
    const response = await axios({
      method: 'POST',
      url: url,
      data: omitBy({ 
        filters: {...filters, sourceSite: process.env.ACCOUNT_TYPE}, 
        paginations, 
        sorting }, isNil)
    });

    return response
  }
  catch(err: any) {
    console.log(err.message)
    return { error: { message: err.message }};
  }
}